import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "p-col-12 scroll-content p-shadow-2",
  ref: "leftSplitterPanel"
}
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid p-p-2" }
const _hoisted_5 = { class: "field p-col-6 p-mb-2" }
const _hoisted_6 = { class: "p-input-filled" }
const _hoisted_7 = { for: "searchMask" }
const _hoisted_8 = { class: "field p-col-6 p-pt-4" }
const _hoisted_9 = { class: "p-input-filled" }
const _hoisted_10 = {
  class: "p-col-12 p-shadow-2",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_11 = {
  class: "recordTable",
  style: {"height":"min-content"}
}
const _hoisted_12 = { class: "p-text-bold p-p-2" }
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid p-mt-2" }
const _hoisted_14 = { class: "p-field p-col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_RecordFields = _resolveComponent("RecordFields")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_RecordViewer = _resolveComponent("RecordViewer")!
  const _component_Splitter = _resolveComponent("Splitter")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Splitter, {
      style: {"height":"100%"},
      stateKey: "freeze.recordView.verticalSplitterLayout"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SplitterPanel, { minSize: 30 }, {
          default: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "p-p-2" }, {
              start: _withCtx(() => [
                _withDirectives(_createVNode(_component_Button, {
                  class: "p-shadow-4",
                  icon: "mdi mdi-chevron-double-up",
                  onClick: _ctx.goBackToRecordList
                }, null, 8, ["onClick"]), [
                  [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.BackToList')]
                ])
              ]),
              end: _withCtx(() => [...(_cache[5] || (_cache[5] = []))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "horizontal-line" }, null, -1)),
            (_ctx.loadingRecord)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "p-col-12 p-p-4" }, [
                    _createElementVNode("div", { class: "loadingSpinner" }, [
                      _createElementVNode("i", {
                        class: "mdi mdi-spin mdi-loading",
                        style: {"fontSize":"8rem"}
                      })
                    ])
                  ], -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Freeze.SearchMask.Hitlist')), 1),
                        _createVNode(_component_Dropdown, {
                          id: "searchMask",
                          modelValue: _ctx.selectedMask,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMask) = $event)),
                          options: _ctx.searchMasks,
                          optionLabel: "desc",
                          placeholder: _ctx.$t('Freeze.SearchMask.ShowAll'),
                          filter: true,
                          autoFilterFocus: true,
                          showClear: true,
                          loading: _ctx.loadingHitList,
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectSearchMask($event))),
                          onShow: _ctx.showDropdownOverlay
                        }, null, 8, ["modelValue", "options", "placeholder", "loading", "onShow"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Button, {
                          label: _ctx.$t('Freeze.Eas.HeaderFields.Metadata'),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMetaData = true)),
                          class: "metaDataButton"
                        }, null, 8, ["label"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_RecordFields, {
                    fields: _ctx.record.recordFields,
                    searchMaskFields: _ctx.searchFields
                  }, null, 8, ["fields", "searchMaskFields"])
                ], 512))
          ]),
          _: 1
        }),
        _createVNode(_component_SplitterPanel, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_RecordViewer, {
                record: _ctx.record,
                selectedDocument: _ctx.selectedDocument,
                onOnChangeDocument: _ctx.openDocument
              }, null, 8, ["record", "selectedDocument", "onOnChangeDocument"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: _ctx.showMetaData,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showMetaData) = $event)),
      style: {width: '50rem'},
      header: _ctx.$t('Freeze.Eas.HeaderFields.Metadata'),
      modal: true,
      dismissableMask: true,
      onHide: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showMetaData = false)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.record.headerFields, (value, name) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: name,
              class: "p-p-2"
            }, [
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t(`Freeze.Eas.HeaderFields.${name}`)) + ": ", 1),
              _createElementVNode("td", null, _toDisplayString(value), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "p-offset-6" }, null, -1)),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              label: _ctx.$t('Forms.Hints.CopyClipboard'),
              icon: "mdi mdi-content-copy",
              type: "button",
              class: "p-button",
              onClick: _ctx.onCopyMetadataToClipboard
            }, null, 8, ["label", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}